import { Component, OnInit } from '@angular/core';
import { Elemento } from 'src/app/shared/models/elemento.model';
import { ElementService } from 'src/app/shared/services/element.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
//import { PartnerDialogComponent } from './component/partner-dialog/partner-dialog.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { KeycloakService } from 'keycloak-angular';
import { ElementoFiltro } from 'src/app/shared/models/elementoFiltro.model';

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss'],
})
export class NewsComponent implements OnInit {
  proximosEventos$: Elemento[] = [];
  eventosFuturos$: Elemento[] = [];
  eventosPasados$: Elemento[] = [];
  constructor(private elementService: ElementService) {}

  img_base = environment.img_base;

  pageIndex = 0;
  desplazamiento = 0;
  limite = 1000;
  totalItems = 0;

  elementos$: Elemento[] = [];
  isMobileWidth = false;

  ngOnInit() {
    if (window.screen.width < 1024) {
      // 768px portrait
      this.isMobileWidth = true;
    }

    this.filtrar(false);
  }

  public filtro = new FormGroup({
    nombre: new FormControl(),
    institucion: new FormControl(),
    tipoModulo: new FormControl(),
    categoria3: new FormControl(),
  });

  public filtrar(cargarMas: boolean): void {
    if (!cargarMas) {
      this.pageIndex = 0;
      this.desplazamiento = 0;
    }
    var filtroParticipantes: ElementoFiltro = new ElementoFiltro();
    filtroParticipantes.estado = 'activo';
    filtroParticipantes.modulo = 'Eventos';
    filtroParticipantes.categorias = [];
    this.elementService
      .getAll(
        this.limite,
        this.desplazamiento,
        filtroParticipantes,
        'orden-asc',
      )
      .subscribe(data => {
        if (!data) return;
        if (cargarMas) {
          (data as any)['elementos']?.forEach((element: Elemento) => {
            this.elementos$.push(element);
          });
        } else {
          this.elementos$ = (data as any)['elementos'] || [];
        }
        this.proximosEventos$ = this.elementService.filterProximosEventos(
          this.elementos$,
        );
        this.proximosEventos$.sort((a, b) =>
          a.fechaInfoInicio <= b.fechaInfoInicio ? 1 : -1,
        );
        this.eventosFuturos$ = this.elementService.filterFuturosEventos(
          this.elementos$,
        );
        this.eventosFuturos$.sort((a, b) =>
          a.fechaInfoInicio <= b.fechaInfoInicio ? 1 : -1,
        );
        this.eventosPasados$ = this.elementService.filterEventosPasados(
          this.elementos$,
        );
        this.eventosPasados$.sort((a, b) =>
          a.fechaInfoInicio <= b.fechaInfoInicio ? 1 : -1,
        );
        this.totalItems = (data as any)['total'] || 0;
      });
    this.pageIndex++;
  }
  public resetear(): void {
    this.filtro.reset();
    this.filtrar(false);
  }

  public loadMore() {
    this.desplazamiento = this.pageIndex * this.limite;
    this.filtrar(true);
  }
}
